import React from 'react';
import bcx from 'bem-classname';
import cx from 'classnames';

type LoginSlideProps = Readonly<{
  imageSrc: string;
  name: string;
  title: string;
  text: string;
}>;

function LoginSlide({ imageSrc, name, title, text }: LoginSlideProps): JSX.Element {
  return (
    <div className="d-flex justify-content-center flex-column align-items-center h-100">
      <img src={imageSrc} alt={name} className={bcx('login', 'logo')} />
      <div className={cx('text-center p-0 m-0', bcx('slide', 'text-wrapper'))}>
        <h1 className={cx('mb-4 font-weight--bold', bcx('slide', 'title'))}>{title}</h1>
        <div className={cx('mx-auto', bcx('slide', 'description-wrapper'))}>
          <p className={cx('font-weight--regular mb-5', bcx('slide', 'description'))}>{text}</p>
        </div>
      </div>
    </div>
  );
}

export default LoginSlide;
